import { Dispatch, SetStateAction, useState } from 'react';

import { WAITING_TIME } from 'coreOld/constants';
import { useCompanyPartsActions } from 'partsOld/hooks';
import { ICompanyPart, IPricing } from 'partsOld/types';
import { PricingType } from 'pricing/enums';

import PricingHeaderView from './PricingHeaderView';

interface IProps {
  part: Partial<ICompanyPart>;
  selectedPrice: IPricing;
  setSelectedPrice: Dispatch<SetStateAction<IPricing>>;
}

const PricingHeader = ({ part, selectedPrice, setSelectedPrice }: IProps) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { upsertCompanyPart } = useCompanyPartsActions();

  const onConfirm = async () => {
    const dataToSend = {
      minimumQuantityWithUom: `${part?.minimumQuantity} ${part?.uom}`,
      orderIncrementWithUom: `${part?.orderIncrement} ${part?.uom}`,
      manufacturerMinimumQuantityWithUom: `${part?.manufacturerMinimumQuantity} ${part?.uom}`,
      manufacturerOrderIncrementWithUom: `${part?.manufacturerOrderIncrement} ${part?.uom}`,
      pkgUnitsWithUom: `${part?.pkgUnits} ${part?.uom}`,
      pricingType: PricingType.CALCULATED,
      id: part?.id,
    };

    changePricingType(dataToSend);

    setTimeout(() => setIsConfirmationOpen(false), WAITING_TIME);
  };

  const onManualCheckbox = async (data) => {
    await changePricingType({ pricingType: data, id: part?.id });
  };

  const changePricingType = async (data) => {
    await upsertCompanyPart(data);
  };

  return (
    <PricingHeaderView
      part={part}
      selectedPrice={selectedPrice}
      setSelectedPrice={setSelectedPrice}
      isFormOpen={isFormOpen}
      setIsFormOpen={setIsFormOpen}
      isConfirmationOpen={isConfirmationOpen}
      setIsConfirmationOpen={setIsConfirmationOpen}
      onConfirm={onConfirm}
      onManualCheckbox={onManualCheckbox}
    />
  );
};

export default PricingHeader;
